import request from '../utils'

const ImageApi = {
    imageTableList: async () => {
        const req = request.get(`/api/visualization/imagetable`)
        const res = await req;
        return res.body;
    },
    imageTableDetail: async (image) => {
        const req = request.get(`/api/visualization/imagetable/${image}`)
        const res = await req;
        return res.body;
    },
    imageTableUpdate: async (image) => {
        const req = request.put(`/api/visualization/imagetable/${image.id}`).send(image);
        const res = await req;
        return res.body;
    },
    imageTableCreate: async (image) => {
        const req = request.post(`/api/visualization/imagetable`).send(image);
        const res = await req;
        return res.body;
    },
    imageFolderUpload: async (imageTableId, folderName) => {
        const req = request.post(`/api/visualization/imagetable/upload/${imageTableId}/${folderName}`);
        const res = await req;
        return res.body;
    },
    imageTableDelete: async (imageTableId) => {
        const req = request.delete(`/api/visualization/imagetable/${imageTableId}`);
        await req;
    },
    imageTableData: async (imageTableId, query) => {
        const req = request.get(`/api/visualization/imagetable/${imageTableId}/data${query}`)
        const res = await req;
        return res.body;
    },
    imageTableDataReq: (imageTableId) => {
        const req = request.get(`/api/visualization/imagetable/${imageTableId}/data`)
        return req;
    },
    imageDetail: (imageTableId, imageId) => {
        const req = request.get(`/api/visualization/imagetable/${imageTableId}/image/${imageId}`);
        return req;
    },
    imageTableFolderStats: async (imageTableId) => {
        const req = request.get(`/api/visualization/imagetable/${imageTableId}/folderstats`);
        const res = await req;
        return res.body;
    }
};

export default ImageApi